export default __webpack_public_path__ + "static/map-573d697b0bf34bcf88c625b273125f6b.png";